import { Component, DestroyRef, inject, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CommunicationService } from './common/communication.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CircleAlertIcon } from 'lucide-angular';

@Component({
	selector: 'paint-communication',
	templateUrl: './communication.component.html',
	styleUrls: ['./communication.component.scss'],
})
export class CommunicationComponent implements OnInit {
	public communicationObservable: Observable<String[]>;
	public currentSlide: number = 0;
	public tooltipMessages: String[] = [];

	private destroyRef = inject(DestroyRef);

	constructor(private communicationService: CommunicationService) {}

	public ngOnInit(): void {
		this.communicationObservable = this.communicationService.paintCommunication.pipe(
			takeUntilDestroyed(this.destroyRef),
			tap((messages: string[]) => {
				return this.cleanCommunicationMessages(messages);
			})
		);
	}

	public slideChanged(slide: number): void {
		this.currentSlide = slide;
	}

	private cleanCommunicationMessages(messages: string[]) {
		if (messages?.length > 1) {
			return (this.tooltipMessages = messages.map(message => {
				// Extract the message string from the rich text HTML string
				return message.replace(/(<([^>]+)>)/gi, '');
			}));
		}
	}

	protected readonly CircleAlertIcon = CircleAlertIcon;
}
